import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/DietaEstudantesBrasileirosAustralia";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/dieta-estudantes-brasileiros-australia")({
  head: () =>
    pageHead({
      title: "Dieta para estudantes brasileiros na Austrália | Clara Camille",
      description:
        "Como comer bem gastando pouco sendo estudante na Austrália. Orçamento semanal, receitas rápidas, lista de compras econômica e dicas práticas.",
      path: "/dieta-estudantes-brasileiros-australia",
      jsonLd: [
        faqJsonLd(faqItems),
        breadcrumbJsonLd([
          { name: "Dieta para estudantes brasileiros na Austrália", path: "/dieta-estudantes-brasileiros-australia" },
        ]),
      ],
    }),
  component: Page,
});
